export default "__VITE_ASSET__f335df29__"